import React from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
  InputReactDatepicker,
} from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useInitialMasterSupplier, useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER } from "./helpers";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export default function FormFilterDaftarPO({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const gudangUtama = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudangPBF.getGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "data"
  );

  const supplier = useInitialMasterSupplier(
    true,
    LIST_URL_WAREHOUSE.masterSupplier.getByPo
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={4}>
            <InputTextMaster
              name='id'
              label='ID PO'
              id='id'
              value={formFilter.id}
              onChange={handleChange("id")}
              placeholder='ID PO'
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name='gudang_id'
              label='GUDANG UTAMA MEDIS'
              id='gudang_id'
              withSearch={true}
              data={gudangUtama}
              value={formFilter.gudang_id}
              labelValue={formFilter.gudang}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  gudang_id: e?.value,
                  gudang: e?.label,
                })
              }
            />
          </Grid>
          <Grid item sm={4}>
            <InputOptionMaster
              name='supplier_id'
              label='SUPPLIER'
              id='supplier_id'
              withSearch={true}
              data={supplier}
              value={formFilter.supplier_id}
              labelValue={formFilter.supplier}
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  supplier_id: e?.value,
                  supplier: e?.label,
                })
              }
            />
          </Grid>

          <Grid item sm={4}>
            <InputReactDatepicker
              selected={formFilter.tglAwal}
              label='TANGGAL AWAL'
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                })
              }
            />
          </Grid>
          <Grid item sm={4}>
            <InputReactDatepicker
              selected={formFilter.tglAkhir}
              label='TANGGAL AKHIR'
              handleChangeToday={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                })
              }
              onChange={(e) =>
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                })
              }
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            onClick={handleSubmit}
            type={typeButton}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}
